import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "app/LineDetails/index.scss";
import SkeletonComp from "app/common/skeleton";
import { RootState } from "../reducers/index";
import { filterLineDetails } from "../LineDetails/actions/index";
import HeaderSection from "./HeaderWrapper";
import LineDetailsTabs from "./Tabs";
import { useNavigate } from "react-router-dom";
import { selectedTab } from "app/LineDetails/actions/index";
// import { failureSavingName, updatedNameId } from '../common/NumberCard/action'

// import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar'

// export interface State extends SnackbarOrigin {
//   open: boolean
// }

const isLoading=(status:any)=>{
  return status === "final" ? false : true;
}

export default function LineDetails(): React.ReactElement {
  const navigate = useNavigate();

  const loading = useSelector((state: RootState) =>isLoading(state.app.apiCallsStatus[0]?.status)
    //state.app.apiCallsStatus[0]?.status === "final" ? false : true
  );
  const headerLoading = useSelector(
    (state: RootState) => state.allLines.userDetails.email.length < 1
  );
  const isEligibilityLine = useSelector(
    (state: RootState) => state.allLines.isEligibilityLine
  );
  const linesPayload = useSelector((state: RootState) => state.allLines);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [searchInputValue, setSearchInputValue] = React.useState(
    linesPayload?.searchKey ? linesPayload.searchKey : ""
  );
  const dispatch = useDispatch();

  const { firstName, email } = Object(linesPayload.userDetails);
  const [searchOnFocus, setSearchOnFocus] = React.useState(false);

  const [closeIcon, setCloseIcon] = React.useState(
    linesPayload?.searchKey ? true : false
  );

  React.useEffect(() => {
    navigate("/line-details");
  }, []);

  // const onAddUser = (): void => {
  //   console.warn("add user");
  // };

  const handleTabsChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    tab: number
  ) => {
    setTabIndex(tab);
    dispatch(selectedTab(tab));
  };

  // const handleChangeViews = (index: number) => {
  //   setTabIndex(index)
  // }

  const onSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const length = value.length;
    if(value){
      setCloseIcon((length > 0));
    }
    
    if (length === 0 ) {
      dispatchFilterLineEmpthy(dispatch,searchInputValue.length)      
    }
    setSearchInputValue(value);
    if (value && length > 1) {
      dispatch(filterLineDetails(value.toLowerCase()));
    } else {
      if (length < 2 && length > 0) {
        dispatch(filterLineDetails(""));
      }
    }
  };
  const searchOnFocusAction = () => {
    setSearchOnFocus(true);
  };

  const clearSearchInput = () => {
    // if (searchInputValue.length > 1) {
    //   dispatch(filterLineDetails(""));
    // }
    dispatchFilterLineEmpthy(dispatch,searchInputValue.length)
    setCloseIcon(false);
    setSearchInputValue("");
  };

  return (
    <React.Fragment>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <HeaderSection
              // onAddUser={onAddUser}
              firstName={firstName}
              email={email}
              loading={headerLoading}
            />

            <Grid item container>
              <SkeletonComp
                loadData={{
                  loading: headerLoading,
                  height: 50,
                  width: 283,
                  className: "smyDigits",
                }}
              >
                <div className="myDigits" tabIndex={0}>
                  <span className="digitcount">My DIGITS</span>
                  <span className="lineCount">
                    {" "}
                    ({linesPayload.count.toString()} Lines)
                  </span>
                </div>
              </SkeletonComp>
            </Grid>
            <LineDetailsTabs
              lineDetails={linesPayload.lineDetails}
              tabIndex={tabIndex}
              handleTabsChange={handleTabsChange}
              // handleChangeViews={handleChangeViews}
              onSearchInput={onSearchInput}
              searchInputValue={searchInputValue}
              loading={loading}
              searchOnFocus={searchOnFocus}
              closeIcon={closeIcon}
              searchOnFocusAction={searchOnFocusAction}
              clearSearchInput={clearSearchInput}
              count={linesPayload.filterLinesCount}
              showSkelton={linesPayload.loading}
              headerLoading={headerLoading}
              isEligibilityLine={isEligibilityLine}
            />
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
}


const dispatchFilterLineEmpthy=(dispatch:any,searchInputLength:any)=>{
  if (searchInputLength > 1) {
    dispatch(filterLineDetails(""));
  }
}